export default __webpack_public_path__ + "static/media/Delivery_2.39ce1be2.svg";